import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, CardTitle } from "reactstrap"
import DonutChart from "./DonutChart"
import "c3/c3.css"

import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"

const MonthlyEarnings = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)
  const [reviews, setReviews] = useState([])
  const [averageRating, setAverageRating] = useState(0)
  const mode = useSelector(state => state.Layout.layoutMode)
  const [mostFrequentReviewer, setMostFrequentReviewer] = useState(null)
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/yelp/getReviews?integrationIds=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.YelpIntegrations[0].id)
                .join(",")
            : activeOrganization.YelpIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchReviews()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      let sum = 0
      const reviewerCounts = {}
      const reviewerProfileUrls = {}

      // Process reviews
      reviews.forEach(review => {
        // Calculate total ratings for average
        sum += parseFloat(review.rating || 0)

        // Count reviews per reviewer and track profile URLs
        if (review.reviewBy) {
          reviewerCounts[review.reviewBy] =
            (reviewerCounts[review.reviewBy] || 0) + 1

          // Save the reviewer's profile URL
          if (!reviewerProfileUrls[review.reviewBy]) {
            reviewerProfileUrls[review.reviewBy] = review.reviewerProfileUrl
          }
        }
      })

      // Calculate average rating
      const avg = sum / reviews.length
      setAverageRating(avg.toFixed(1))

      // Find most frequent reviewer
      const mostFrequent = Object.entries(reviewerCounts).reduce(
        (acc, [reviewer, count]) =>
          count > acc.count
            ? { reviewer, count, profileUrl: reviewerProfileUrls[reviewer] }
            : acc,
        { reviewer: null, count: 0, profileUrl: null },
      )

      setMostFrequentReviewer(mostFrequent)
    }
  }, [reviews])

  return (
    <React.Fragment>
      <Card className="br">
        <CardBody>
          <CardTitle className="h4 mb-4">Yelp Reviews Summary</CardTitle>

          <Row className="text-center mt-4">
            <div className="col-12">
              {mostFrequentReviewer?.reviewer ? (
                <h5 className="font-size-20">
                  <a
                    href={mostFrequentReviewer.profileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: mode === "dark" ? "#2990DF" : "#0066cc",
                    }}
                  >
                    {mostFrequentReviewer.reviewer}
                  </a>
                </h5>
              ) : (
                <h5 className="font-size-20">No Data</h5>
              )}
              <p className="text-muted">Most Frequent Reviewer</p>
            </div>
          </Row>

          <div dir="ltr">
            <DonutChart />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
